import { render } from "./FriendsList.vue?vue&type=template&id=797d6a3f"
import script from "./FriendsList.vue?vue&type=script&lang=js"
export * from "./FriendsList.vue?vue&type=script&lang=js"
script.render = render

export default script